export default {
    "视频": "Videos",
    "文章": "Articles",
    "频道": "Channels",
    "活动": "Events",
    "用户": "People",
    "搜索": "Searched ",
    "共找到": "found ",
    "个结果": " results",
    "对结果不满意？请告诉我们": "Not what you were looking for? Let us know",
    "综合排序": "Default",
    "最新创作": "Newest",
    "最多浏览": "Most Views",
    "最多点赞": "Most likes",
    "成员": "Member",
    "没有匹配的视频": "Searched video unavailable",
    "没有匹配的文章": "Searched article unavailable",
    "没有匹配的频道": "Searched channel unavailable",
    "没有匹配的活动": "Searched event unavailable",
    "没有匹配的用户": "Searched user unavailable",
    "热门周榜": "Monthly Trends",


}


// WEBPACK FOOTER //
// ./src/languages/en/search.js